module.exports = __webpack_public_path__ + "static/media/lock_black.24dcd2ba.svg";